import {wrap} from '../../loading-overlay'
;(function module() {
  angular
    .module('app.ui.form.ctrls')
    .controller('CreateUpdateEmployerModalController', [
      '$log',
      '$timeout',
      '$uibModal',
      '$location',
      'logger',
      'usSpinnerService',
      'EmployersApi',
      'SharedApi',
      '$uibModalInstance',
      'selectedEmployerId',
      'userService',
      'CandidateProfileApi',
      '$rootScope',
      function controller(
        $log,
        $timeout,
        $uibModal,
        $location,
        logger,
        usSpinnerService,
        EmployersApi,
        SharedApi,
        $uibModalInstance,
        selectedEmployerId,
        userService,
        CandidateProfileApi,
        $rootScope
      ) {
        let vm = this
        $rootScope.$on('employer-deleted', (event, {employerDeleted}) => {
          if (
            selectedEmployerId === employerDeleted &&
            !$rootScope.isEmployerDeleted
          ) {
            logger.notify('error', 'Employer Deleted by Other Admin')
            vm.cancel()
          }
        })
        vm.showOnError = false
        vm.showOnSuccess = false
        vm.alertMsg = ''
        vm.employerSpinnerId = 'spinner-firm-management'
        vm.selectedEmployerId = selectedEmployerId
        const pageInitialize = () => {
          vm.page = {
            entityPlaceholder: 'Employer',
            mandatoryPlaceholder: vm.isPrivatePractice === false ? '' : '*',
            behaviorPlaceholder: vm.selectedEmployerId ? 'Edit' : 'Create',
          }
        }

        vm.cancel = () => {
          $uibModalInstance.dismiss('cancel')
        }

        pageInitialize()

        //   $scope.$root.title = `${vm.page.behaviorPlaceholder} ${vm.page.entityPlaceholder} | Lexstep`

        // $scope.canViewAddFirmAssignedAdmin = () => {
        //   return accountPermission.canViewAddFirmAssignedAdmin($scope.user)
        // }

        vm.changeStatus = (status, message) => {
          switch (status) {
            case 201:
              vm.alertMsg =
                'Congratulations! Employers has been Successfully created.'
              vm.showOnSuccess = true
              break
            case 200:
              vm.alertMsg =
                'Congratulations! Employers has been Successfully updated.'
              vm.showOnSuccess = true
              break
            case 440:
              $location.url('/signin')
              break
            case 404:
              vm.alertMsg = 'Page Not Found. Please try again.'
              vm.showOnError = true
              break
            case 400:
              vm.alertMsg = message
              vm.showOnError = true
              break
            case 500:
              vm.alertMsg =
                'Could not connect to the server. Please try again later.'
              vm.showOnError = true
              break
            case 100:
              vm.alertMsg =
                'Please select a Employer by clicking the checkboxes before deleting.'
              vm.showOnError = true
              break
            default:
              vm.alertMsg = 'An error has occurred. Please try again.'
              vm.showOnError = true
              break
          }
        }

        const discardMultipleField = () => {
          vm.employer.lawProfile = {
            nqSalary: vm.employer.lawProfile.nqSalary,
            nqSalaryVisible: vm.employer.lawProfile.nqSalaryVisible,
          }
        }

        vm.addEmployer = async () => {
          if (!vm.isPrivatePractice && vm.employer.lawProfile)
            discardMultipleField()
          const payload = employerDto()
          startSpinner()
          EmployersApi.createEmployer(payload)
            .then(async successResponse => {
              if (vm.selectedFile) {
                const file = vm.selectedFile
                let formData = new FormData()
                formData.append('file', file)
                await EmployersApi.uploadEmployerLogo(
                  successResponse.data.id,
                  formData
                )
              }

              stopSpinner()

              $uibModalInstance.close({
                employer: successResponse.data,
                type: 'created',
              })
            })
            .catch(addUpdateErrorResponseHandler)
            .finally(stopSpinner)
        }

        vm.updateEmployer = async () => {
          const result = await wrap(async () => {
            console.debug('updateEmployer')
            if (!vm.isPrivatePractice && vm.employer.lawProfile)
              discardMultipleField()
            startSpinner()
            const payload = employerDto()
            EmployersApi.updateEmployerById(vm.selectedEmployerId, payload)
              .then(async successResponse => {
                if (vm.selectedFile) {
                  const file = vm.selectedFile
                  let formData = new FormData()
                  formData.append('file', file)
                  await EmployersApi.uploadEmployerLogo(
                    vm.selectedEmployerId,
                    formData
                  )
                }

                stopSpinner()
                $uibModalInstance.close({
                  employer: successResponse.data,
                  type: 'updated',
                })
              })
              .catch(addUpdateErrorResponseHandler)
              .finally(stopSpinner)
          })
          return result
        }

        const employerDto = () => {
          const payload = angular.copy(vm.employer)

          // eslint-disable-next-line unicorn/no-null
          payload.agentId = payload.agentId === 0 ? null : payload.agentId
          payload.approved = vm.employer.approved
          payload.professions = ['law']
          payload.contactEmail = vm.employer.contactEmail
            ? vm.employer.contactEmail
            : undefined
          payload.specialties = vm.employer.practiceAreas
          payload.specialties = vm.selectedCategory
            ? [...payload.specialties, vm.selectedCategory]
            : payload.specialties
          payload.categories = [
            ...new Set(
              payload.specialties &&
                payload.specialties.map(specialty => specialty.categoryId)
            ),
          ]

          if (
            vm.editableEmployerName &&
            payload.name.trim() === vm.editableEmployerName.trim()
          )
            delete payload.name
          delete payload.practiceAreas
          delete payload.categoryId
          delete payload.id
          delete payload.logo

          return payload
        }

        const startSpinner = () => usSpinnerService.spin(vm.employerSpinnerId)

        const stopSpinner = () => usSpinnerService.stop(vm.employerSpinnerId)

        const addUpdateErrorResponseHandler = errorResponse => {
          $log.info(`Error occurred in Add/Update Employer`, errorResponse)
          logger.notify('error', errorResponse.data.message)
        }

        vm.changeEmployerCategory = categoryId => {
          if (categoryId) {
            vm.employer.approved = true

            vm.selectedCategory = vm.categories.find(
              category => category.id === categoryId
            )

            if (vm.selectedCategory.name === 'Private Practice')
              vm.isPrivatePractice = true
            else vm.isPrivatePractice = false
            pageInitialize()
          } else {
            vm.selectedCategory = undefined
          }
        }

        vm.openDeleteEmployerModal = employerId => {
          const modalInstance = $uibModal.open({
            templateUrl: 'delete-employer-modal.html',
            controller: 'DeleteEmployerController',
            controllerAs: 'ctrl',
            resolve: {
              employerId: function() {
                return employerId
              },
            },
          })
          modalInstance.result.then(
            deletedEmployer => {
              if (deletedEmployer) {
                $uibModalInstance.close({
                  employer: deletedEmployer,
                  type: 'deleted',
                })
              } else {
                vm.alertMsg = 'An error has occurred. Please try again.'
                vm.showOnError = true
              }
            },
            () => {}
          )
        }

        vm.onEmployerApproved = approvedCheckBoxValue => {
          if (approvedCheckBoxValue === false) {
            vm.employer.categoryId = undefined
            vm.selectedCategory = undefined
          }

          if (
            approvedCheckBoxValue === true &&
            vm.employer.categoryId === undefined
          ) {
            logger.notify(
              'error',
              'Category must be selected for approved employer'
            )
            vm.employer.approved = false
          }

          pageInitialize()
        }

        vm.openLocationModal = (selectedLocations, event) => {
          event.preventDefault()
          event.stopPropagation()
          const modalInstance = $uibModal.open({
            templateUrl: 'locations-modal.html',
            controller: 'LocationsModalController',
            controllerAs: 'ctrl',
            resolve: {
              locationList: function() {
                return vm.locationsList
              },
              selectedLocations: function() {
                return selectedLocations
              },
              limit: function() {
                return 0
              },
              locationModalHeading: function() {
                return false
              },
              displayNextButton: function() {
                return false
              },
            },
          })
          modalInstance.result.then(
            selectedLocations => {
              vm.selectedLocation = selectedLocations.length > 0
              vm.employer.locations = angular.copy(selectedLocations)
            },
            () => {}
          )
        }

        vm.openPracticeModal = (selectedPractice, event) => {
          event.preventDefault()
          event.stopPropagation()
          const onlyParentPracticeArea = vm.legalPracticeAreaList.filter(
            ({parentId}) => parentId === null
          )
          const modalInstance = $uibModal.open({
            templateUrl: 'practice-area-modal.html',
            controller: 'PracticeAreaController',
            controllerAs: 'ctrl',
            resolve: {
              practiceAreaList: function() {
                return onlyParentPracticeArea
              },
              selectedPractice: function() {
                return selectedPractice
              },
              limit: function() {
                return 0
              },
              isAdminProfile: function() {
                return true
              },
              displayNextButton: function() {
                return false
              },
            },
          })
          modalInstance.result.then(
            selectPractices => {
              vm.selectedPracticesShow = selectPractices.length > 0
              vm.employer.practiceAreas = angular.copy(selectPractices)
            },
            () => {}
          )
        }

        vm.loadEmployer = async () => {
          vm.user = await userService.getUser()
          startSpinner()

          if (vm.selectedEmployerId) {
            try {
              const {
                data: employerRecord,
                status: employerStatus,
              } = await EmployersApi.getEmployerById(vm.selectedEmployerId)
              if (employerStatus === 200) {
                vm.employerRecord = employerRecord
              }
            } catch (error) {
              vm.changeStatus(error.status, error.message)
            }
          }

          const [
            {data: locationsList},
            {data: legalPracticeAreaList},
            {data: legalEmployerTypeList},
            {data: candidateAgents},
          ] = await Promise.all([
            SharedApi.getAllLocations({
              supported: true,
              regions: true,
            }),
            SharedApi.getCategoryById(1),
            SharedApi.getCategoryById(2),
            CandidateProfileApi.getAdminAndCorporateUsers(),
          ])
          vm.candidateAgentsList = candidateAgents
          vm.legalPracticeAreaList = legalPracticeAreaList.specialties
          vm.legalEmployerTypeList = legalEmployerTypeList
          vm.locationsList = locationsList
          $timeout(() => {
            vm.initializeEmployer()
            stopSpinner()
          }, 300)
        }

        vm.initializeEmployer = () => {
          vm.employer = {professions: ['law'], practiceAreas: [], locations: []}
          vm.isPrivatePractice = true
          vm.employer.lawProfile = {}
          vm.modalTitle = 'Create Employer'
          vm.selectedPracticesShow = false
          vm.showPracticeButton = true
          vm.selectedLocation = false
          vm.showLocationButton = true
          vm.categories = vm.legalEmployerTypeList.specialties
          vm.selectivity = []
          let employerSelectivity = ''
          for (let index = 1; index <= 6; index++) {
            employerSelectivity += '$'
            vm.selectivity = [
              ...vm.selectivity,
              {id: index, name: employerSelectivity},
            ]
          }

          vm.selectivity = [...vm.selectivity, {id: 0, name: 'Uncategorized'}]
          if (vm.employerRecord) {
            vm.initializeEditEmployer(vm.employerRecord)
          }
        }

        vm.initializeEditEmployer = existingEmployer => {
          vm.modalTitle = 'Edit Employer'
          vm.editEmployerModal = true
          vm.employer = {
            logo: existingEmployer.logo,
            id: existingEmployer.id,
            approved: existingEmployer.approved,
            name: existingEmployer.name,
            selectivity: existingEmployer.selectivity,
            contactName: existingEmployer.contactName,
            contactEmail: existingEmployer.contactEmail,
            address: existingEmployer.address,
            isVisible: existingEmployer.isVisible,
            description: existingEmployer.description,
            agentId: existingEmployer.agentId,
            practiceAreas: [],
            locations: [],
          }
          vm.editableEmployerName = angular.copy(existingEmployer.name)

          if (
            existingEmployer.professions.find(
              profession => profession.id === 'law'
            )
          ) {
            vm.employer.lawProfile = {
              size: existingEmployer.lawProfile.size,
              sizeVisible: existingEmployer.lawProfile.sizeVisible,
              targetHours: existingEmployer.lawProfile.targetHours,
              targetHoursVisible:
                existingEmployer.lawProfile.targetHoursVisible,
              associatesPerPartner:
                existingEmployer.lawProfile.associatesPerPartner,
              associatesPerPartnerVisible:
                existingEmployer.lawProfile.associatesPerPartnerVisible,
              profitPerEquityPartner:
                existingEmployer.lawProfile.profitPerEquityPartner,
              profitPerEquityPartnerVisible:
                existingEmployer.lawProfile.profitPerEquityPartnerVisible,
              nqSalary: existingEmployer.lawProfile.nqSalary,
              nqSalaryVisible: existingEmployer.lawProfile.nqSalaryVisible,
            }
          }

          if (existingEmployer.categories.length > 0) {
            const practiceAreas = existingEmployer.categories.find(
              category => category.id === 1
            )
            const category = existingEmployer.categories.find(
              category => category.id === 2
            )
            if (practiceAreas && practiceAreas.specialties.length > 0) {
              vm.employer.practiceAreas = practiceAreas.specialties.map(
                practiceArea => {
                  practiceArea.isSelected = true
                  return practiceArea
                }
              )
              vm.selectedPracticesShow = practiceAreas.specialties.length > 0
              vm.showPracticeButton = practiceAreas.specialties.length === 0
            }

            if (category && category.specialties.length > 0) {
              vm.employer.categoryId = category.specialties.find(
                specialty => specialty.categoryId === 2
              ).id
              vm.changeEmployerCategory(vm.employer.categoryId)
            }
          }

          if (existingEmployer.locations.length > 0)
            vm.employer.locations = existingEmployer.locations.map(location => {
              location.isSelected = true
              return location
            })
          vm.selectedLocation = existingEmployer.locations.length > 0
          vm.showLocationButton = existingEmployer.locations.length === 0
        }

        vm.loadEmployer()
      },
    ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/create-update-employer/create-update-employer-modal.ctrl.js